import { styled } from '@mui/system';
import { Box } from '@mui/material';
import { fontFamilies } from '../../../../../constants/theme';
import { SectionHeading, SectionSubtext } from '../../styles';
export const SectionWrapper = styled(Box)(({ theme }) => ({
  maxWidth: '1200px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const SectionTitle = styled(SectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  fontSize: '50px',
  fontFamily: fontFamilies.gotham,
  fontWeight: 400,
  lineHeight: '58px',
  letterSpacing: '-.4px',
  textAlign: 'center',
  marginBottom: '50px',
  [theme.breakpoints.down('md')]: {
    fontSize: '36px',
    lineHeight: '44px',
    marginBottom: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    lineHeight: '36px',
    marginBottom: '30px',
  },
}));

export const BottomText = styled(SectionSubtext)(({ theme }) => ({
  ...theme.typography.subtext,
  fontFamily: fontFamilies.quicksand,
  fontWeight: 600,
  fontSize: '22px',
  lineHeight: '32px',
  textAlign: 'center',
  whiteSpace: 'pre-line',
  margin: '0 auto',
  marginTop: '50px',
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
    lineHeight: '28px',
    marginTop: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: '30px',
  },
}));

export const ButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 50,
});
